import React from 'react';  
import './index.css';
import userRequest, { userApi } from 'common/request';
import { Modal , Toast} from 'antd-mobile';
import { Input } from 'antd';
const { TextArea } = Input;


function closest(el, selector) {
  const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

class AskFor extends React.Component {
    state = {
        modal1: false,
        modal2: false,
        applyText: '',
        status: 0,
        courseApply: null
    }
    componentWillMount () {
      this.memberApply()
    }
    memberApply = () => {
      const params = this.getParams()
      userRequest.get(`/passport`,params).then(res => {
        console.log('-------------------------------', res)
        if (!res.success) return
        res.result&&(res.result.content=JSON.parse(res.result.content))
        this.setState({courseApply: res.result, applyText: res.result&&res.result.content.content})
      })
    }
    getParams = () => {
      const getCookie = (name) => {
        let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)")
        if (arr = document.cookie.match(reg)) return unescape(arr[2])
        else return null
      }

      let token = getCookie('_token')
      let pattern=/{i:\d+;s:\d+:"_token";i:\d+;s:\d+:"(.+?)";}/
      token = pattern.exec(decodeURIComponent(token))
      token = token?`${token[1]}`: ''
      const params = {
        _token: token,
        r:'course/member-apply',
        id:  this.props.courseId
      }
      return params
    }
    onClose = (key) => {
        this.setState({
          [key]: false
        })
    }
    onOpen = (key) => {
      this.setState({
          [key]: true
        })
    }
    onWrapTouchStart = (e) => {
        // fix touch to scroll background page on iOS
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
          return;
        }
        const pNode = closest(e.target, '.am-modal-content');
        if (!pNode) {
          e.preventDefault();
        }
    }
    courseHandle = () => {
       this.setState({modal1: true})     
    }
    onChange = (event) => {
        this.setState({applyText: event.target.value})
    }
    applyRequest = () => {
      const {courseApply} = this.state
      if (courseApply&&courseApply.status==0) return this.onClose('modal1')
      const params = this.getParams()
      const bodyData = {
        name: `${this.props.info.title}选修课程申请`,
        content: JSON.stringify({
          course_id: this.props.courseId,
          content: `${this.props.info.title}选修课程申请`,
          type: this.props.info.type,
          member: {
            realname: JSON.parse(localStorage.getItem('userinfo')).realname,
            id: JSON.parse(localStorage.getItem('userinfo')).structures[0].id,
            label: JSON.parse(localStorage.getItem('userinfo')).structures[0].display_name
          }
        }),
        reason: this.state.applyText
      }
      userRequest.postRequest(`/passport`, bodyData, {params}).then(res => {
        if (!res.success) return
        Toast.success('申请提交成功', 1)
        this.setState({courseApply: {status: 0}})
        this.onClose('modal1')
      })
    }
    statusHandle = status => {
        this.setState({status})
    }
    render () {
        let {courseApply} = this.state
        return (
            <div className="askForAuth">
                {courseApply&&courseApply.status==0?<div className='underReview'>审核中</div>:null}
                {courseApply&&courseApply.status==2?<div className='reject' onClick={() => this.onOpen('modal2')}>申请被驳回</div>:null}
                
                <div className='speedBtn' onClick={() => this.onOpen('modal1')}>
                    {
                        courseApply == null ? '申请选修':
                        courseApply.status == 0 ? '已申请选修':
                        '重新申请选修'
                    }
                
                </div>
                <Modal
                  className='programApplication'
                  visible={this.state.modal1}
                  transparent
                  maskClosable={false}
                  onClose={() => {this.onClose('modal1')}}
                  title="申请选修"
                  footer={[
                    { text: '取消', onPress: () => this.onClose('modal1')},
                    { text: '确定', onPress: this.applyRequest}
                    ]}
                  afterClose={() => {}}
                >
                  <div>
                    <TextArea value={this.state.applyText} disabled={courseApply&&courseApply.status==0} onChange={this.onChange} placeholder='请输入申请理由' rows={4}></TextArea>
                  </div>
                </Modal>
                <Modal
                  className='programApplication rejectApplication'
                  visible={this.state.modal2}
                  transparent
                  maskClosable={false}
                  onClose={() => {this.onClose('modal2')}}
                  title="申请选修"
                  footer={[
                    { text: '确定', onPress: () => {this.onClose('modal2')}}
                    ]}
                  afterClose={() => {}}
                >
                  <div className='reason'>
                    <div>我：{this.state.applyText} </div>
                    <div>老师：{this.state.courseApply&&this.state.courseApply.remark}</div>
                  </div>
                </Modal>
            </div>
            
        )
    }
}

export default AskFor